export default class ContractDetailsModel {
    idContrato: number;
    dataContrato: string;
    idClube: string;
    idStatusContrato: number;
    idCategoria: string;
    dtCancelamento: string;
    numero_contrato: string;

    constructor(
        idContrato: number,
        dataContrato: string,
        idClube: string,
        idStatusContrato: number,
        idCategoria: string,
        dtCancelamento: string,
        numero_contrato: string
    ) {
        this.idContrato = idContrato;
        this.dataContrato = dataContrato;
        this.idClube = idClube;
        this.idStatusContrato = idStatusContrato;
        this.idCategoria = idCategoria;
        this.dtCancelamento = dtCancelamento;
        this.numero_contrato = numero_contrato;
    }

    static fromApiResponse(data: any): ContractDetailsModel[] {
        return data.map((contrato: any) => new ContractDetailsModel(
            contrato.id_contrato,
            contrato.data_contrato,
            contrato.ID_CLUBE,
            contrato.ID_STATUS_CONTRATO,
            contrato.ID_CATEGORIA,
            contrato.dt_cancelamento,
            contrato.num_contrato,
        ));
    }
}
